import script from "./TeamHome.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamHome.vue?vue&type=script&setup=true&lang=js"

import "./TeamHome.vue?vue&type=style&index=0&id=7ef7aecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef7aecc"]])

export default __exports__